import Vue from 'vue'
import Vuex from 'vuex'
import storage from '../utils/storage'
import employeesModule from './modules/employees'
import behaviorsModule from './modules/behaviors'
import settingsModule from './modules/settings'
import casesModule from './modules/cases'
import surveysModule from './modules/surveys'
import evaluationInstructionsModule from './modules/evaluationInstructions'
import scoringRulesModule from './modules/scoringRules'
import reportContentConfigsModule from './modules/reportContentConfigs'
import departureFeedbacksModule from './modules/departureFeedbacks'
import adminsModule from './modules/admins'
import tasksModule from './modules/tasks'

Vue.use(Vuex)

const taskSettingsSyncPlugin = store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'SET_CURRENT_TASK') {
      const taskId = state.tasks.currentTask && state.tasks.currentTask.task_id
      if (taskId) {
        store.commit('LOAD_TASK_SETTINGS', taskId)
        store.commit('LOAD_TASK_RULES', taskId)
        store.commit('LOAD_TASK_INSTRUCTIONS', taskId)
      }
    }
  })
}

const store = new Vuex.Store({
  modules: {
    employees: employeesModule,
    behaviors: behaviorsModule,
    settings: settingsModule,
    cases: casesModule,
    surveys: surveysModule,
    evaluationInstructions: evaluationInstructionsModule,
    scoringRules: scoringRulesModule,
    reportContentConfigs: reportContentConfigsModule,
    departureFeedbacks: departureFeedbacksModule,
    admins: adminsModule,
    tasks: tasksModule
  },
  plugins: [taskSettingsSyncPlugin],
  state: {
    // 兼容旧 key：优先读 user_real，回退到 user（仅保留登录态，业务数据不从本地缓存加载）
    user: storage.get('user_real') || storage.get('user') || null,
    currentEvaluation: null,
    evaluations: []
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      storage.set('user_real', user)
    },
    SET_EVALUATIONS(state, list) {
      state.evaluations = list
      storage.set('evaluations_real', list)
    },
    ADD_EVALUATION(state, evalData) {
      // 反规范化存储：评估记录自包含员工信息，避免删除员工后数据悬空
      const enriched = {
        ...evalData,
        employee_email: evalData.employee_email || '',
        employee_no: evalData.employee_no || '',
        task_id: evalData.task_id || 1
      }
      state.evaluations.unshift(enriched)
      storage.set('evaluations_real', state.evaluations)
    },
    SET_CURRENT_EVALUATION(state, evalData) {
      state.currentEvaluation = evalData
      storage.set('current_evaluation_real', evalData)
    },
    LOGOUT(state) {
      state.user = null
      state.currentEvaluation = null
      state.evaluations = []
      storage.set('user_real', null)
      storage.set('current_evaluation_real', null)
      storage.set('evaluations_real', [])
    }
  }
})

// 跨标签页同步：监听 localStorage 变化
if (typeof window !== 'undefined') {
  const PREFIX = 'talent_retention_v3_'
  const keyMap = {
    [PREFIX + 'admin_employees']: ['SET_EMPLOYEES', 'employees', 'employees'],
    [PREFIX + 'admin_resigned']: ['SET_RESIGNED', 'employees', 'resignedEmployees'],
    [PREFIX + 'admin_behaviors']: ['SET_BEHAVIORS', 'behaviors', 'behaviors'],
    [PREFIX + 'admin_settings']: ['SET_SETTINGS', 'settings', 'settings'],
    [PREFIX + 'admin_cases']: ['SET_CASES', 'cases', 'cases'],
    [PREFIX + 'admin_courses']: ['SET_COURSES', 'cases', 'courses'],
    [PREFIX + 'admin_surveys']: ['SET_SURVEYS', 'surveys', 'surveys'],
    [PREFIX + 'admin_survey_responses']: ['SET_RESPONSES', 'surveys', 'responses'],
    [PREFIX + 'talent_retention_v3_instructions']: ['SET_INSTRUCTIONS', 'evaluationInstructions', 'instructions'],
    [PREFIX + 'talent_retention_v3_scoring_rules']: ['SET_SCORING_RULES', 'scoringRules', 'rules'],
    [PREFIX + 'talent_retention_v3_report_contents']: ['SET_CONTENTS', 'reportContentConfigs', 'contents'],
    [PREFIX + 'talent_retention_v3_departure_feedbacks']: ['SET_FEEDBACKS', 'departureFeedbacks', 'feedbacks'],
    [PREFIX + 'talent_retention_v3_admins']: ['SET_ADMINS', 'admins', 'admins'],
    [PREFIX + 'tr_v3_tasks_real']: ['SET_TASKS_LIST', 'tasks', 'tasksList'],
    [PREFIX + 'tr_v3_current_task_real']: ['SET_CURRENT_TASK', 'tasks', 'currentTask'],
    [PREFIX + 'tr_v3_users_real']: ['SET_USERS', 'employees', 'users'],
    [PREFIX + 'evaluations_real']: ['SET_EVALUATIONS', null, 'evaluations'],
    [PREFIX + 'current_evaluation_real']: ['SET_CURRENT_EVALUATION', null, 'currentEvaluation'],
    [PREFIX + 'user_real']: ['SET_USER', null, 'user']
  }

  window.addEventListener('storage', function(e) {
    const mapping = keyMap[e.key]
    if (!mapping) return
    if (e.newValue === null) return
    try {
      const data = JSON.parse(e.newValue)
      store.commit(mapping[0], data)
    } catch (err) {
      console.warn('[storage sync] failed to sync key:', e.key, err)
    }
  })
}

export default store
